import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type SearchFilterKeys = "selectFilter" | "selectFilterText";
type SearchFilterActionType = {
    key: SearchFilterKeys;
    value: string;
};
type HandlerType = CustomHandler<SearchFilterActionType>;

export const SetRoleFilter: HandlerType = props => {
    props.dispatch({ type: "Custom/SecurityRoles/SetSearchFilter", filters: props.parameter });
};

export const chain = [SetRoleFilter];

const setRoleFilterSearchFilter = createHandlerChainRunner(chain, "setRoleFilterSearchFilter");
export default setRoleFilterSearchFilter;
